import { atom } from 'jotai';
import { SETTINGS } from './constants';
import { TOKENS } from '~/core/tokens';
import { ZERO_ADDRESS } from '~/core/constants';
import { blinkoHardModeStorage } from '~/core/storages';

export const atomUserInput = atom({
  tollAmount: SETTINGS.TOLL_OPTIONS[0].options[0].value.toString(),
  tollToken: TOKENS[ZERO_ADDRESS],
});

export const atomShowCustomBetAmount = atom(false);
export const atomHasNewAnnouncement = atom(false);

export const atomHardMode = atom(blinkoHardModeStorage.get() === 'true');
export const atomAllowAllWallets = atom(false);
export const atomIsIgamingDemo = atom(false);

// In-memory demo balance for the igaming-demo route. Starts at $10,000.
export const atomDemoBalanceUsd = atom(10000);